import Vue from 'vue'

export default {
  namespaced: true,

  state: {
    loading: {},
    progress: {}
  },

  getters: {
    loading (state) {
      return state.loading
    },
    progress (state) {
      return state.progress
    }
  },

  mutations: {
    addLoader: (state, { id, value }) => {
      if (!state.loading[id]) {
        Vue.set(state.loading, id, value)
      }
    },
    deleteLoader: (state, { id }) => {
      if (state.loading[id]) {
        Vue.delete(state.loading, id)
      }
    },
    updateProgress: (state, { id, progress }) => {
      if (!state.progress[id]) {
        Vue.set(state.progress, id, progress)
      }
    },
    deleteProgress: (state, { id }) => {
      if (state.progress[id]) {
        Vue.delete(state.progress, id)
      }
    }
  },

  actions: {
    startLoader: ({ commit }, { id = 'default', value = true }) => {
      commit('addLoader', { id, value })
    },
    stopLoader: ({ commit }, { id = 'default' }) => {
      commit('deleteLoader', { id })
    },
    stopAllLoaders: ({ commit, state }, { ids = [] }) => {
      if (!ids.length) {
        Object.keys(state.loading).forEach((key) => commit('deleteLoader', { id: key }))
      } else {
        ids.forEach((key) => commit('deleteLoader', { id: key }))
      }
    },
    startProgress: ({ commit }, { id = 'default', value = true }) => {
      commit('addLoader', { id, value })
      commit('updateProgress', { id, progress: 0 })
    },
    updateProgress: ({ commit }, { id = 'default', progress }) => {
      commit('updateProgress', { id, progress: (progress.loaded / progress.total) * 100 })
    },
    stopProgress: ({ commit }, { id = 'default' }) => {
      commit('deleteLoader', { id })
      commit('deleteProgress', { id })
    }
  }
}
